import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    source: [],
    destination: [],
    tracker: "",
    service: "",
    template: {},
    wizzardSource: "",
};

const leadsWizardSourceDestinationSlice = createSlice({
    name: "leadslastAddedSourceDestinationState",
    initialState,
    reducers: {
        leadslastAddedSource(state, action) {
            state.source = action.payload;
        },
        leadslastAddedDestination(state, action) {
            state.destination = action.payload;
        },
        leadslastAddedTracker(state, action) {
            state.tracker = action.payload;
        },
        leadsdeleteLastAddedDest(state, action) {
            state.destination = [];
        },
        leadsdeleteLastAddedSource(state, action) {
            state.source = [];
        },
        lastAddedService(state, action) {
            state.service = action.payload;
        },
        resetLastAddedService(state, action) {
            state.service = "";
        },
        lastAddedWizzardSource(state, action) {
            state.wizzardSource = action.payload;
        },
        resetLastAddedSourceApiData(state) {
            state.wizzardSource = "";
        },
        templateData(state, action) {
            state.template = action.payload;
        },
    },
});

export const {
    lastAddedService,
    leadslastAddedSource,
    leadslastAddedDestination,
    leadslastAddedTracker,
    resetLastAddedSourceApiData,
    resetLastAddedService,
    leadsdeleteLastAddedDest,
    leadsdeleteLastAddedSource,
    lastAddedWizzardSource,
    templateData,
} = leadsWizardSourceDestinationSlice.actions;
export default leadsWizardSourceDestinationSlice.reducer;
